var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 0H3.42C2.7 0 1.9.807 1.9 1.5v7.627c0 .693.8 1.503 1.52 1.503h11.16c.72 0 1.47-.81 1.47-1.503V1.5c0-.693-.75-1.5-1.47-1.5zm0 9.127H3.42V1.5h11.16v7.627zM.5 11.68c-.276 0-.507.229-.43.493.23.784.994 1.327 1.82 1.327h14.22c.89 0 1.595-.588 1.817-1.327.08-.265-.15-.493-.427-.493H.5z",
    fill: "#242527"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 3.56a.5.5 0 00-.5-.5H5.5a.5.5 0 00-.5.5v.473a.5.5 0 00.5.5h6.33a.5.5 0 00.5-.5V3.56zM9.54 5.813a.5.5 0 00-.5-.5H5.5a.5.5 0 00-.5.5v.474a.5.5 0 00.5.5h3.54a.5.5 0 00.5-.5v-.474z",
    fill: "#242527"
  })));
}
export default SvgReport;